import styled, { css } from 'styled-components';

import { ColorsTransparencies, mobileCssQuerist, spacing } from 'styles/theme';
import { Card } from 'styles/shared';

export const AuthWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

interface AuthFormProps {
    $backgroundColor?: ColorsTransparencies;
}

export const AuthForm = styled(Card).attrs({ as: 'form' })<AuthFormProps>`
    // Custom width to line up with child Cloudfare Turnstile width
    width: 366px;
    align-items: center;

    ${mobileCssQuerist(
        css`
            width: 342px;
        `
    )}

    ${({ $backgroundColor }) =>
        $backgroundColor &&
        css`
            background-color: ${$backgroundColor};
        `}
`;

export const StepsCompleteTextWrapper = styled.div`
    margin: ${spacing.large};
    max-width: 460px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const OAuthIconWrapper = styled.div`
    margin: -3px ${spacing.xSmall} -3px 0;
    padding: 0;
    display: flex;
    align-items: center;
`;
